import styled from 'styled-components'

export const Title = styled.h2``

export const NotFound = () => {
  return <Title>Page not found</Title>
}
